import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '@/lib/format';

export interface SearchInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'leftIcon' | 'rightIcon' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  leftIcon?: ReactNode;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { value, onChange, onClear, leftIcon, placeholder = 'Search…', className, ...rest },
  ref,
) {
  return (
    <div data-tour="search" className="relative w-full">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral pointer-events-none">
        {leftIcon ?? <Search size={16} />}
      </span>
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn('input pl-10 pr-10', className)}
        {...rest}
      />
      {value && (
        <button
          type="button"
          onClick={() => {
            onChange('');
            onClear?.();
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral hover:text-ink transition-colors"
          aria-label="Clear search"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
});
